(function(window, document, $, undefined) {

	$(function() {

		/**
		 * Simple Generic Carousel
		 */

		$('.jsSimpleGenericCarousel').each(function() {

			var $slider = $(this);
			var $nav = $slider.parent().closest('.section').find('.jsSimpleGenericCarouselArrow');

			$slider.slick({
				dots: 			false,
				arrows: 		false,
				slidesToShow: 	4,
				slidesToScroll: 1,
				infinite: 		false,
				responsive: [
					{
						breakpoint: 1366,
						settings: {
							slidesToShow: 3,
						}
					},
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 520,
						settings: {
							slidesToShow: 1,
						}
					}
				]
			});

			$nav.on('click', function(e) {
				e.preventDefault();
				$slider.slick($(this).data('dir'));

				var curr = $slider.slick('slickCurrentSlide');

				$(this).parent().find('[data-dir="slickPrev"]')
								.toggleClass('is_disabled', !(curr > 0));

				$(this).parent().find('[data-dir="slickNext"]')
								.toggleClass('is_disabled', !(curr < $slider.find('.slick-slide').length - 1));
			});

		});

		/**
		 * Testimonials Carousel
		 */

		$('.jsTestimonialsCarouselWrapper').each(function() {

			var $wrapper 	= $(this);
			var $slider 	= $wrapper.find('.jsTestimonialsCarousel');
			var $nav 		= $wrapper.find('.jsTestimonialsCarouselArrow');
			var $dots 		= $wrapper.find('.jsTestimonialsCarouselDots');

			$slider.slick({
				dots: 			false,
				arrows: 		false,
				slidesToShow: 	1,
				slidesToScroll: 1,
				infinite: 		true,
				fade: 			true,
				cssEase: 		'linear',
				speed: 			500,
			});

			$nav.on('click', function(e) {
				e.preventDefault();

				$slider.slick($(this).data('dir'));

				if ( $(this).data('dir') == 'slickPrev' ) {
					if ( $dots.find('span.is_active').prev().length > 0 ) {
						var $active = $dots.find('span.is_active').prev();
						$dots.children().removeClass('is_active');
						$active.addClass('is_active');
					} else {
						$dots.children().removeClass('is_active');
						$dots.children().last().addClass('is_active');
					}
				} else {
					if ( $dots.find('span.is_active').next().length > 0 ) {
						var $active = $dots.find('span.is_active').next();
						$dots.children().removeClass('is_active');
						$active.addClass('is_active');
					} else {
						$dots.children().removeClass('is_active');
						$dots.children().first().addClass('is_active');
					}
				}
			});

			$dots.find('span').on('click', function() {
				$slider.slick('slickGoTo', $(this).index());
				$(this).parent().children().removeClass('is_active');
				$(this).addClass('is_active');
			});

		});

		/**
		 * Images Carousel
		 */

		$('.jsImagesCarouselWrapper').each(function() {

			var $wrapper 	= $(this);
			var $slider 	= $wrapper.find('.jsImagesCarousel');
			var $nav 		= $wrapper.find('.jsImagesCarouselArrow');
			var $dots 		= $wrapper.find('.jsImagesCarouselDots');

			$slider.slick({
				dots: 			false,
				arrows: 		false,
				slidesToShow: 	1,
				slidesToScroll: 1,
				infinite: 		true,
				cssEase: 		'linear',
				speed: 			500,
				centerMode: 	true,
				variableWidth:  true,
			});

			$nav.on('click', function(e) {
				e.preventDefault();

				$slider.slick($(this).data('dir'));

				if ( $(this).data('dir') == 'slickPrev' ) {
					if ( $dots.find('span.is_active').prev().length > 0 ) {
						var $active = $dots.find('span.is_active').prev();
						$dots.children().removeClass('is_active');
						$active.addClass('is_active');
					} else {
						$dots.children().removeClass('is_active');
						$dots.children().last().addClass('is_active');
					}
				} else {
					if ( $dots.find('span.is_active').next().length > 0 ) {
						var $active = $dots.find('span.is_active').next();
						$dots.children().removeClass('is_active');
						$active.addClass('is_active');
					} else {
						$dots.children().removeClass('is_active');
						$dots.children().first().addClass('is_active');
					}
				}
			});

			$dots.find('span').on('click', function() {
				$slider.slick('slickGoTo', $(this).index());
				$(this).parent().children().removeClass('is_active');
				$(this).addClass('is_active');
			});

		});

		/**
		 * Services slider
		 */
		$('.jsServicesCarouselWrapper').each(function() {

			var $wrapper 	= $(this);
			var $slider 	= $wrapper.find('.jsServicesCarousel');
			var $nav		= $wrapper.find('.jsServicesCarouselNav');

			$slider.slick({
				dots: 			false,
				arrows: 		false,
				slidesToShow: 	4,
				slidesToScroll: 1,
				infinite: 		false,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2
						}
					}
				]
			});

			$nav.on('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				$slider.slick($(this).data('dir'));
			});

		});

		/**
		 * Team slider
		 */
		$('.jsTeamCarousel').each(function() {

			var $wrapper = $(this);
			var $infoSlider = $wrapper.find('.jsTeamInfoCarousel');
			var $profileSlider = $wrapper.find('.jsTeamProfileCarousel');
			var $nav = $wrapper.find('.jsTeamProfileCarouselNav');

			$infoSlider.slick({
				dots: false,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				swipe: false,
				draggable: false,
				speed: 500,
                fade: true,
                cssEase: 'linear'
			});

			$profileSlider.slick({
				dots: false,
				arrows: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				infinite: true,
				swipe: false,
				draggable: false,
				responsive: [
					{
						breakpoint: 1366,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 1,
						}
					},
				]
			});

			$nav.on('click', function(e) {
				e.preventDefault();
				e.stopPropagation();
				$infoSlider.slick($(this).data('dir'));
				$profileSlider.slick($(this).data('dir'));
			});

		});

		/**
		 * Anchor links
		 */
		$('a[href^=\\#]').on('click', function(e) {
			e.preventDefault();

			var $elem = $($.attr(this, 'href'));
			if ( $elem.length > 0 ) {
				$('html, body').animate({
					scrollTop: $elem.offset().top
				}, 700);
			} else if ( $.attr(this, 'href') == '#to-top' ) {
				$('html, body').animate({ scrollTop: 0 }, 700);
			}
		});

		/**
		 * FAQ row expand
		 */
		$('.jsFAQHead').on('click', function(e) {
			e.preventDefault();

			$(this).find('.jsFAQTitle').toggleClass('is_active');
			$(this).parent().closest('.jsFAQRow').find('.jsFAQClose').toggleClass('is_active');
			$(this).parent().closest('.jsFAQRow').find('.jsFAQContent').slideToggle();
		});

		/**
		 * Pinned Blocks
		 */
		
		if ( $('.pinned-blocks').length > 0 ) {

			function pinActiveBlock( elem ) {
				var idx = $(elem).index();
				$('.pinned-blocks__box--stack').removeClass('is_active');
				$('.pinned-blocks__box--stack').eq(idx).addClass('is_active');
			}

			$('.pinned-blocks__box--fluid').each(function() {
				$(this).waypoint({
					handler: function ( dir ) {
						if ( dir === 'down' ) {
							pinActiveBlock( this.element );
						}
					}, offset: '50%'
				});
				$(this).waypoint({
					handler: function ( dir ) {
						if ( dir === 'up' ) {
							pinActiveBlock( this.element );
						}
					}, offset: '-50%'
				});
			});

		}

		$('.jsOffcanvasMenuToggler').on('click', function(e) {
			e.preventDefault();
			$('.jsOffcanvasMenu').toggleClass('is_active');
			$('body').toggleClass('is_open', $('.jsOffcanvasMenu').hasClass('is_active'));
			$('.offcanvas-menu__nav .sub-menu').slideUp();
			$('.offcanvas-menu__nav .expand-btn').removeClass('is_open');
		});

		$('.offcanvas-menu__nav .expand-btn').on('click', function(e) {
			e.preventDefault();
			$(this).parent().parent().find('.sub-menu').slideToggle();
			$(this).toggleClass('is_open');
		});

		render_gform_consent_fields();
		jQuery(document).bind('gform_post_render', function() {
			render_gform_consent_fields();
		});

		(new Headroom(document.querySelector('.site-header'))).init();

	});

	function render_gform_consent_fields() {

		$('.gform_wrapper').each(function() {

			var $form 		= $(this).find('form');
			var $consent 	= $form.find('.gform_body .gfield.consent');
			var $footer 	= $form.find('.gform_footer');

			if ( $consent.length > 0 ) {
				$consent.wrapAll('<ul class="consent-gfields"></ul>');
				$form.find('.consent-gfields').prependTo($footer);
			}

		});

	}

})(window, document, jQuery);
